import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const financialYearList = createAsyncThunk("financialYear/list", async ({ navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + "financial_year",
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const financialYear = createSlice({
    name: "financialYear",
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(financialYearList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(financialYearList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(financialYearList.rejected, (state) => {
            state.loading = false
        })
    },
})

export default financialYear.reducer;